import React from 'react';
import { Routes, Route, Navigate, BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import HomeScreen from './components/home/HomeScreen';
import ProfileScreen from './components/profile/ProfileScreen';
import FoodDetailScreen from './components/food/FoodDetailScreen';
import { AuthProvider } from './context/AuthContext';
import AuthCallback from './pages/AuthCallback';
import PrivacyPolicy from './pages/PrivacyPolicy';
import QuestionnaireScreen from './components/questionnaire/QuestionnaireScreen';
import ResultScreen from './components/questionnaire/ResultScreen';
import PhotoEvaluationScreen from './components/photo/PhotoEvaluationScreen';
import RecommendationsScreen from './components/recommendations/RecommendationsScreen';
import EvaluationOptionsScreen from './components/home/EvaluationOptionsScreen';
import NotificationsScreen from './components/notifications/NotificationsScreen';
import Contact from './pages/Contact';

const queryClient = new QueryClient();

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <QueryClientProvider client={queryClient}>
          <Toaster />
          <Routes>
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/" element={<HomeScreen />} />
            <Route path="/profile" element={<ProfileScreen />} />
            <Route path="/food/:id" element={<FoodDetailScreen />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/questionnaire" element={<QuestionnaireScreen />} />
            <Route path="/result" element={<ResultScreen />} />
            <Route path="/photo-evaluation" element={<PhotoEvaluationScreen />} />
            <Route path="/recommendations" element={<RecommendationsScreen />} />
            <Route path="/evaluation-options" element={<EvaluationOptionsScreen />} />
            <Route path="/notifications" element={<NotificationsScreen />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </QueryClientProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
